import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useContent } from '../content/ContentContext';
import BrandMark from './BrandMark';

const labels = {
  home: '\u9996\u9875',
  courses: '\u8bfe\u7a0b\u4ecb\u7ecd',
  portal: '\u8bfe\u7a0b\u7cfb\u7edf',
  news: '\u65b0\u95fb\u4e2d\u5fc3',
  about: '\u5173\u4e8e\u6211\u4eec',
  schools: '\u5b66\u6821\u5408\u4f5c',
  trial: '\u83b7\u53d6\u5408\u4f5c\u65b9\u6848',
  menu: '\u83dc\u5355',
};

const navItems = [
  { name: labels.home, to: '/' },
  { name: labels.courses, to: '/courses' },
  { name: labels.portal, to: '/course-portal' },
  { name: labels.news, to: '/news' },
  { name: labels.about, to: '/about' },
  { name: labels.schools, to: '/schools' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const { site } = useContent();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-300"
      style={{
        background: 'rgba(255,255,255,0.72)',
        backdropFilter: 'saturate(180%) blur(18px)',
        WebkitBackdropFilter: 'saturate(180%) blur(18px)',
        borderBottom: scrolled ? '1px solid var(--line)' : '1px solid transparent',
        boxShadow: scrolled ? '0 6px 24px -18px rgba(15,31,61,0.4)' : 'none',
      }}
    >
      <nav className="container-x">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <BrandMark size="md" />
            <span className="leading-none">
              <span className="block text-[16px] font-extrabold tracking-tight" style={{ color: 'var(--ink)' }}>{site.brandName}</span>
              {site.productBrand && <span className="block text-[11px] mt-0.5" style={{ color: 'var(--muted)' }}>{site.productBrand}</span>}
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-full px-3.5 py-2 text-[14px] font-medium transition-colors ${isActive ? '' : 'hover:bg-blue-50'}`
                }
                style={({ isActive }) => isActive
                  ? { background: 'var(--blue-50)', color: 'var(--blue-600)', fontWeight: 600 }
                  : { color: 'var(--body)' }}
              >
                {item.name}
              </NavLink>
            ))}
          </div>

          <div className="hidden lg:block">
            <Link to="/contact" className="btn btn-blue py-2 px-4 text-[14px]">{labels.trial}</Link>
          </div>

          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 rounded-lg cursor-pointer" style={{ color: 'var(--ink)' }} aria-label={labels.menu}>
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4">
            {navItems.map((item) => (
              <NavLink key={item.name} to={item.to} end={item.to === '/'}
                className="block rounded-lg px-3 py-3 text-[16px] font-medium"
                style={({ isActive }) => isActive ? { background: 'var(--blue-50)', color: 'var(--blue-600)' } : { color: 'var(--ink)' }}>
                {item.name}
              </NavLink>
            ))}
            <Link to="/contact" className="btn btn-blue w-full mt-2">{labels.trial}</Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
